module.exports = __webpack_public_path__ + "img/title-4.20633667.png";